import React, { FC } from 'react';

import { LogoProps } from '../types';

import styles from './Logo.module.scss';

const Logo: FC<LogoProps> = ({
  width = '131',
  height = '32',
  fill = 'none',
  viewBox = '0 0 131 32',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      role="img">
      <g clipPath="url(#clip0_119_11559)">
        <path className={styles.firstPartText}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24.1016 9.49533L21.9905 23.1147C21.0443 31.2642 25.3987 32.7186 30.3561 32.7186C35.1187 32.7186 38.8814 30.2105 39.9679 24.7803L42.3244 9.49533C42.9838 2.27782 39.6131 0.718567 34.6029 0.718567C27.4901 0.718567 25.0064 4.7167 24.1016 9.49533ZM5.64615 1.18436L0.783203 32.0977H8.96743L10.7434 18.9711L12.1333 32.0977H20.2409L17.77 15.3206L24.5649 1.18436H17.1522L11.67 12.9128L13.5231 1.18436H5.64615ZM41.8941 32.0977L46.7753 1.18436H57.0426V15.3206L60.9139 1.18436H71.4337L66.6367 32.0977H59.5674L62.5971 11.8862L57.0426 32.0977H51.909V12.3095L48.9634 32.0977H41.8941ZM31.105 14.886C31.4347 12.7533 31.7199 10.9084 31.8927 9.65158C32.3147 6.58111 32.8377 5.61151 33.9739 5.79165C35.2528 5.99443 34.8715 8.19915 34.5927 9.81134C34.5584 10.0094 34.5257 10.1986 34.4978 10.374C34.4231 10.8438 34.2473 11.9673 34.0182 13.4309C33.4659 16.9607 32.604 22.4685 32.1043 25.5532C31.8835 26.9165 31.4034 27.7482 30.4085 27.6193C29.3621 27.4837 29.4617 26.0649 29.604 25.0134C30.0608 21.6404 30.6292 17.9636 31.105 14.886Z"
              fill="black" />
        <path className={styles.secondPartText}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M91.4406 9.49532L89.3294 23.1147C88.3833 31.2642 92.7377 32.7186 97.695 32.7186C102.458 32.7186 106.22 30.2105 107.307 24.7803L109.663 9.49532C110.323 2.27782 106.952 0.718567 101.942 0.718567C94.8291 0.718567 92.3454 4.7167 91.4406 9.49532ZM75.3808 20.6294L72.6877 1.12344H80.1778V13.1798L84.0491 1.12344H91.5392L82.7867 20.6294L81.1035 32.0368H73.7817L75.3808 20.6294ZM109.381 32.0368L114.009 1.12344H122.915C129.73 1.12344 130.987 3.39196 130.758 8.18777C130.501 13.5876 128.501 14.691 125.708 15.4655C128.958 16.3036 130.382 17.7394 129.151 23.9021L129.119 24.0462C127.537 31.1876 127.349 32.0368 117.226 32.0368H109.381ZM98.4262 14.9023L98.4262 14.9025C97.9504 17.9802 97.3819 21.6569 96.9252 25.03C96.7829 26.0814 96.6833 27.5002 97.7297 27.6358C98.7246 27.7647 99.2047 26.933 99.4255 25.5698C99.9252 22.485 100.787 16.9771 101.339 13.4473L101.34 13.4464L101.34 13.4436C101.569 11.9819 101.744 10.8599 101.819 10.3905C101.847 10.2152 101.88 10.0262 101.914 9.82828L101.914 9.82787C102.193 8.21568 102.574 6.01095 101.295 5.80817C100.159 5.62803 99.6359 6.59764 99.2139 9.66811C99.0411 10.9249 98.7559 12.7698 98.4262 14.9023ZM121.115 6.5375L120.212 13.2822C122.175 13.2822 122.73 13.0365 123.07 9.94951C123.083 9.83368 123.098 9.7104 123.115 9.58199C123.29 8.19239 123.542 6.20158 121.115 6.5375ZM119.334 18.1342L118.026 26.6028C120.437 26.6028 120.707 25.6008 121.196 22.6177C121.882 18.4331 121.537 18.1342 119.334 18.1342Z"
              fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_119_11559">
          <rect width="130"
                height="32"
                fill="white"
                transform="translate(0.783203 0.718567)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Logo;
